import { Controller } from "@hotwired/stimulus"

// Automatically processes all links within Trix rich text content
// and ensures they open in a new tab with proper security attributes
export default class extends Controller {
  connect() {
    this.processExternalLinks()
  }

  processExternalLinks() {
    // Find all Trix content containers
    const containers = this.element.querySelectorAll('.trix-content')

    containers.forEach(container => {
      // Find all anchor tags within each container
      const links = container.querySelectorAll('a')

      links.forEach(link => {
        // Add target="_blank" to open in new tab
        link.setAttribute('target', '_blank')

        // Add rel="noopener noreferrer" for security
        // noopener: prevents new page from accessing window.opener
        // noreferrer: prevents passing referrer information
        link.setAttribute('rel', 'noopener noreferrer')
      })
    })
  }
}
